export default __webpack_public_path__ + "static/media/importImage.9b25afc8.svg";